import React from 'react';
import { Datagrid, TextField, ReferenceField, useRecordContext } from 'react-admin';

import DateField from '../common/fields/DateField';
import RecordSplitButton from '../common/buttons/RecordSplitButton';
import ExportPDFButton from './InvoiceActionsButtons/ExportPDFButton';
// import SendInvoiceButton from './InvoiceActionsButtons/SendInvoiceButton';
import ReverseInvoiceButton from './InvoiceActionsButtons/ReverseInvoiceButton';
import CloneInvoiceButton from './InvoiceActionsButtons/CloneInvoiceButton';
import PaidInvoiceButton from './InvoiceActionsButtons/PaidInvoiceButton';
import StatusField from './fields/StatusField';
import InvoiceTypeField from './fields/InvoiceTypeField';


const CustomRecordSplitButton = (props) => {
    const record = useRecordContext();

    return (
        <RecordSplitButton record={record} {...props} hasEdit={record?.status === 'draft'} hasDelete={record?.status === 'draft'}>
            <ExportPDFButton record={record} />
            {/* <SendInvoiceButton record={record} /> */}
            <ReverseInvoiceButton record={record} />
            <CloneInvoiceButton record={record} />
            <PaidInvoiceButton record={record} />
        </RecordSplitButton>
    );
};

const InvoiceRow = props => (
    <Datagrid rowClick="edit" {...props}>
        <InvoiceTypeField source="invoice_type" />
        <TextField source="number" />
        <ReferenceField label="Customer" source="customer_id" reference="customers" linkType="show" allowEmpty>
            <TextField source="name" />
        </ReferenceField>
        <DateField source="invoiced_at" />
        <TextField source="total_untaxed" />
        <TextField source="total_tax" />
        <StatusField source="status" />
        <CustomRecordSplitButton />
    </Datagrid>
);

export default InvoiceRow;